<template>
  <div id="app">
    <score></score>
    <navigation></navigation>
    <transition :name="transitionName" mode="out-in">
      <router-view :key="'a' + $route.path"></router-view>
    </transition>
  </div>
</template>

<script>
import navigation from "./components/Navigation";
import score from "./components/Score";

export default {
  name: "app",
  components: {
    navigation: navigation,
    score: score,
  },
  data() {
    return {
      transitionName: "fadel",
    };
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      const toDepth = parseInt(to.path.substring(1));
      const fromDepth = parseInt(from.path.substring(1));

      this.transitionName = toDepth < fromDepth ? "fader" : "fadel";
      next();
    });
  },
};
// https://avogtil.no/drikkestatus/#/17/?m=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
</script>

<style lang="scss">
body.page-template-habit-calculator .swContent {
  padding-top: 0 !important;
}
.icon {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDMuMTYgMTAzLjE2Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmY2RjNTt9LmNscy0ye2ZpbGw6IzIzMWYyMDt9LmNscy0ze2ZpbGw6I2ZmZmZmZTt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkFzc2V0IDI0PC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iNTEuNTgiIGN5PSI1MS41OCIgcj0iNTEuNTgiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik01Miw4MS44N2EyNS4yOSwyNS4yOSwwLDAsMS0yMC05Ljc0LDEuMjUsMS4yNSwwLDAsMSwyLTEuNTQsMjIuODgsMjIuODgsMCwwLDAsMzYsMCwxLjI1LDEuMjUsMCwwLDEsMiwxLjU0QTI1LjI2LDI1LjI2LDAsMCwxLDUyLDgxLjg3WiIvPjxjaXJjbGUgY2xhc3M9ImNscy0zIiBjeD0iNjguNTIiIGN5PSI0MS40NyIgcj0iOC4wNiIvPjxjaXJjbGUgY2xhc3M9ImNscy0yIiBjeD0iNjguNTIiIGN5PSI0MS40NyIgcj0iMy4xMSIvPjxjaXJjbGUgY2xhc3M9ImNscy0zIiBjeD0iMzQuNjQiIGN5PSI0MS40NyIgcj0iOC4wNiIvPjxjaXJjbGUgY2xhc3M9ImNscy0yIiBjeD0iMzQuNjQiIGN5PSI0MS40NyIgcj0iMy4xMSIvPjwvZz48L2c+PC9zdmc+);
}

.fader-enter-active,
.fader-leave-active,
.fadel-enter-active,
.fadel-leave-active {
  transition: all 0.25s ease;
}

.fadel-enter,
.fader-leave-active {
  opacity: 0;
  -webkit-transform: translate(10vw, 0);
  transform: translate(10vw, 0);
}
.fadel-leave-active,
.fader-enter {
  opacity: 0;
  -webkit-transform: translate(-10vw, 0);
  transform: translate(-10vw, 0);
}

@media (max-width: 39.9375em) {
  .calcnav .calcnav__btn.isActive {
    background-color: #083650;
    border-color: #083650;
    &:hover {
      background-color: #ef5050;
      border-color: #ef5050;
    }
  }
}

.slide {
  @media (max-width: 639px) {
    margin-top: 80px;
  }
  @media (min-width: 640px) {
    font-size: 18px;
  }
}
@media (max-width: 767px) {
  .mt-2 {
    margin-top: 2rem;
  }
  .mt-3 {
    margin-top: 3rem;
  }
  [type="radio"] + label {
    max-width: 100%;
    margin: 0;
  }
}
</style>
